// PlainBadges.tsx
import React from 'react'
import Box from '@mui/material/Box'
import { EmtTypography } from 'emt-components-v2'
import NextImage from 'next/image'
import VariantImages from '@/assets/VariantImages'
import { PlainWidthBadgeType } from '@/data/PetSitter/PetSitterProfile'

type Props = {
  plainBadges: PlainWidthBadgeType[]
}

const PlainBadges: React.FC<Props> = ({ plainBadges }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {plainBadges.map((plainBadge) => (
        <Box
          key={plainBadge['@id']}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            backgroundColor: '#FFF1E6',
            borderRadius: '16px',
            padding: '16px',
          }}
        >
          <NextImage src={VariantImages.Donateur} width={41} alt="donateur" />
          {/* <EmtIcon
            className={plainBadge.icon.type}
            sx={{
              fontSize: '41px',
              color: plainBadge.color || '#E66301',
            }}
          /> */}
          <Box sx={{ color: '#E66301' }}>
            <EmtTypography variant="h5">{plainBadge.title}</EmtTypography>
            <EmtTypography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
              {plainBadge.description}
            </EmtTypography>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default PlainBadges
